/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Shoulder_RaiseInputs */

const en_us2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`shoulder raise`)
};

const pt_br2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`elevação de ombros`)
};

const es_419_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`elevación de hombros`)
};

const pt_pt2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`elevação de ombros`)
};

const fr_fr2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`élévations d'épaules`)
};

const de_de2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seitheben`)
};

const it_it2_catalog_movement_shoulder_raise = /** @type {(inputs: Catalog_Movement_Shoulder_RaiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`alzate per le spalle`)
};

/**
* | output |
* | --- |
* | "shoulder raise" |
*
* @param {Catalog_Movement_Shoulder_RaiseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_shoulder_raise = /** @type {((inputs?: Catalog_Movement_Shoulder_RaiseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Shoulder_RaiseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_shoulder_raise(inputs)
	if (locale === "es-419") return es_419_catalog_movement_shoulder_raise(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_shoulder_raise(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_shoulder_raise(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_shoulder_raise(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_shoulder_raise(inputs)
	return en_us2_catalog_movement_shoulder_raise(inputs)
});
export { catalog_movement_shoulder_raise as "catalog.movement.shoulder_raise" }